<script>
import {useStore} from "vuex";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import router from "@/router";
import {Share} from "@capacitor/share";

export default {
  name: "ProfilePage",
  setup(){

    let store = useStore()

    let profile = ref(FreeWorld.PinkMan(store.state.profile , 'de'))

    function log_out() {
      Swals.Question('آیا از حساب کاربری خود خارج می شوید؟' , 'خروج از حساب').then((res)=>{
        if (res.isConfirmed){
          store.commit('empty_state')
          localStorage.clear()
          router.push({name: 'SplashPage'})
        }
      })
    }
    
    async function share_code() {
      await Share.share({
        title: profile.value.user_code,
        text: 'شما توسط ' + profile.value.name + 'با کد معرف : ' + profile.value.user_code + 'به اپلیکیشن سنگین سواران دعوت شده اید',
        url: 'https://sangin-savaran.com/',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }

    return{
      profile,
      log_out,
      share_code,
    }
  }
}
</script>

<template>
  
  <div id="main" class="bg-color-liner">
    <div style="height: 12rem" class="d-flex align-items-center justify-content-evenly p-4">
      <div class="d-flex align-items-center">
        <div class="profile ms-3 animated-background">
          <img class="profile" src="../assets/img/defult-profile.svg" alt="">
        </div>

        <div class="">
          <p class="font-5 text-white font-bold mb-3">{{ profile.name }}</p>
          <p class="font-5 text-white font-bold">کد معرف :</p>
        </div>
      </div>

      <div class="">
        <p class="font-5 text-white font-bold mb-3">{{ profile.phone }}</p>

        <div class="d-flex align-items-center">
          <p class="font-5 text-white font-bold ms-3">{{ profile.user_code }}</p>
          <img @click="share_code" class="icon" src="../assets/img/icon-shareBgWhite.svg" alt="">
        </div>
      </div>
    </div>

    <div style="height: calc(100% - 12rem)" id="chile-main" class="bg-main rounded-top-5 py-3 px-5 pt-4">

      <router-link :to="{name:'MyCars'}" class="d-flex align-items-center text-decoration-none">
        <img class="icon" src="../assets/img/icon-van.svg" alt="">

        <p class="font-4 text-color font-bold me-3">خودرو های من</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'MyAdvertising'}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-menu-button-wide-fill.svg" alt="">

        <p class="font-4 text-color font-bold me-3">آگهی های من</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'BillOfLadingPage'}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-barname.svg" alt="">

        <p class="font-4 text-color font-bold me-3">بارنامه های من</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'CarService' , params:{action:'car_expenses'}}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-payCar.svg" alt="">

        <p class="font-4 text-color font-bold me-3">مخارج خودرو</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'MarksPage'}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-mark.svg" alt="">

        <p class="font-4 text-color font-bold me-3">آگهی های نشان شده</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'MyProfile'}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-edit.svg" alt="">

        <p class="font-4 text-color font-bold me-3">ویرایش اطلاعات</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'QuestionsPage'}" class="d-flex text-decoration-none align-items-center">
        <img class="icon" src="../assets/img/icon-qusion.svg" alt="">

        <p class="font-4 text-color font-bold me-3">سوالات متداول</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'TicketsPage'}" class="d-flex text-decoration-none align-items-center">
        <img class="icon" src="../assets/img/icon-ticket.png" alt="">

        <p class="font-4 text-color font-bold me-3">ثبت تیکت</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'PrivacyPage' , params:{action:'apprules'}}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-ruls.svg" alt="">

        <p class="font-4 text-color font-bold me-3">قوانین و مقررات</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'PrivacyPage' , params:{action:'privacy'}}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-privacy.svg" alt="">

        <p class="font-4 text-color font-bold me-3">حریم خصوصی</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <router-link :to="{name:'PrivacyPage' , params:{action:'about_us'}}" class="text-decoration-none d-flex align-items-center">
        <img class="icon" src="../assets/img/icon-aboutUs.svg" alt="">

        <p class="font-4 text-color font-bold me-3">درباره ما</p>
      </router-link>

      <div class="hr-div bg-color-light my-4"></div>

      <div @click="log_out" class="d-flex align-items-center mb-5">
        <img class="icon" src="../assets/img/icon-logout.svg" alt="">

        <p class="font-4 text-color font-bold me-3">خروج از کاربری</p>
      </div>


    </div>
  </div>

</template>

<style scoped>
.profile {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}
.hr-div{
  width: 100%;
  height: 1px;
}
.icon{
  width: 2.3rem;
  height: 2.3rem;
}
</style>